<template>
  <DataTable
    :columns="columnList"
    defaultColumnOrderDir="DESC"
    :defaultColumnOrderIndex="5"
    :url="dataURL"
    emptyListMessage="No credit notes found"
    :filterOptions="filterOptions"
    :displayTools="true"
    :hasDateRangeFilter="true"
    :displayFilters="displayFilters"
    :displayDateFilter="displayDateFilter"
    :displayExportTools="displayExportTools"
    :displaySearch="displaySearch"
    :displayPageCount="displayPageCount"
    :displayFooterNote="displayFooterNote"
    exportTitle="Credit Notes">
    <template v-slot:title>
      <slot name="title" />
    </template>
    <template v-slot:tools>
      <slot name="tools" />
    </template>
    <template v-slot:row="row">
      <tr :key="row.data.id">
        <td class="table-data-nav-link">
          <LinkCreditNote :id="row.data.id" :name="row.data.sequenceNumber" :newTab="openNewTab" />
        </td>
        <td>
          <LabelBadge :labelClass="`label-creditnote-status-${row.data.status}`">{{row.data.status | formatLookupName(CreditNoteStatusTypeLookup)}}</LabelBadge>
        </td>
        <td>
          {{row.data.description}}
        </td>
        <td>
          <LinkContact :id="row.data.contactId" :name="row.data.contactName" />
        </td>
        <td>
          <LinkUser :id="row.data.userId" :name="row.data.userName" />
        </td>
        <td>{{row.data.createdAt | formatDateTime}}</td>
        <td>
          {{row.data.totalCredit | formatCurrency}}
        </td>
        <td>
          {{row.data.availableAmount | formatCurrency}}
        </td>
      </tr>
    </template>
    <template v-slot:summary="summary">
      <tr key="summary">
        <td>Totals</td>
        <td colspan="5"> </td>
        <td>{{summary.data.totalCreditAmount | formatCurrency}}</td>
        <td>{{summary.data.totalAvailableAmount | formatCurrency}}</td>
      </tr>
    </template>
  </DataTable>
</template>

<script>
import Utils from '@/utils/utils'

import { CreditNoteStatusTypes, CreditNoteStatusTypeLookup } from '@/store/types'

export default {
  name: 'CreditNoteDataTable',
  props: {
    openNewTab: {
      type: Boolean,
      default: false
    },
    displaySearch: {
      type: Boolean,
      default: true
    },
    displayPageCount: {
      type: Boolean,
      default: true
    },
    displayExportTools: {
      type: Boolean,
      default: true
    },
    displayFilters: {
      type: Boolean,
      default: true
    },
    displayDateFilter: {
      type: Boolean,
      default: true
    },
    displayFooterNote: {
      type: Boolean,
      default: true
    },
    filterContactId: Number,
    filterOrderId: Number,
    filterType: String
  },
  created() {
    this.CreditNoteStatusTypeLookup = CreditNoteStatusTypeLookup
    this.CreditNoteStatusTypes = CreditNoteStatusTypes
  },
  computed: {
    title() {
      return this.$route.meta.title
    },
    dataURL() {
      var params = {
        filter: {}
      }
      if(this.filterContactId)
        params.filter.contactId = this.filterContactId
      if(this.filterOrderId)
        params.filter.orderId = this.filterOrderId

      return '/accounts/creditnotes?' + $.param(params)
    },
  },
  data() {
    return {
      filterOptions: [
        {
          field: 'status',
          name: 'Status',
          options: [
            { name: Utils.getLookupName(CreditNoteStatusTypeLookup, CreditNoteStatusTypes.available), value: CreditNoteStatusTypes.available, class: 'label-creditnote-status-available' },
            { name: Utils.getLookupName(CreditNoteStatusTypeLookup, CreditNoteStatusTypes.credited), value: CreditNoteStatusTypes.credited, class: 'label-creditnote-status-credited' },
            { name: Utils.getLookupName(CreditNoteStatusTypeLookup, CreditNoteStatusTypes.cancelled), value: CreditNoteStatusTypes.cancelled, class: 'label-creditnote-status-cancelled' },
          ]
        }
      ],
      columnList: [
        { title: "Credit Note", data: "sequenceNumber" },
        { title: "Status", data: "status" },
        { title: "Description", data: "description" },
        { title: "Contact", data: "contact.name" },
        { title: "Created By", data: "user.name" },
        { title: "Created On", data: "createdAt", dateFilter: true, type: 'datetime' },
        { title: "Total Credit", data: "totalCredit", type: 'currency', totalField: 'totalCreditAmount' },
        { title: "Available Amount", data: "availableAmount", type: 'currency', totalField: 'totalAvailableAmount' }
      ]
    }
  },
  methods: {
  }
};
</script>
